//Import for Webpack
import './PageTransitionModule.scss';

import Module from 'core/ts/system/Module';
/**
 * @ignore
 */
export default class PageTransitionModule extends Module {}
